import { render, staticRenderFns } from "./DatabaseEntryForm.vue?vue&type=template&id=470fc96c"
import script from "./DatabaseEntryForm.vue?vue&type=script&lang=js"
export * from "./DatabaseEntryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports